// Centralized SEO configuration

export const SITE_URL = "https://www.lialearning.com";
export const SITE_NAME = "LIA Learning";
export const ORG_NAME = "Long Island Academy";

export const DEFAULT_TITLE = "LIA Learning｜K-12 课程与家教平台";
export const DEFAULT_DESCRIPTION =
  "Founded in 1990 in Syosset, NY, Long Island Academy helps K‑12 students improve academics and attitudes with dedicated teachers and a motivating curriculum.";

// Use asset path preserved by Vite config (no hash under src/assets)
export const DEFAULT_OG_IMAGE = 
  "/assets/images/logo/LIA_logo.png";


